import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, } from 'react-bootstrap';
import Select from 'react-select';
import { ChooseComponent, useFetch, useTranslation, usePermission } from '@np/np_webcomponentlib'

import { API_MASTERDATA } from '../../shared/consts/api'

import { EntityType, DataEntityType, EntityFormPropsWithType, initEntity, columnsForChoose } from './BankTypes'
import DRRateComissionList from '../DRRateComission/DRRateComissionList';


// import { ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'






export const BankForm = ({ title, idInit, handleClose, initEntityProps }: EntityFormPropsWithType) => {

    const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('$component_name');

    const [currentID, setCurrentID] = useState<string | null>(idInit)
    const [entity, setEntity] = useState<EntityType | DataEntityType>(initEntityProps !== undefined ? initEntityProps : initEntity)

    useEffect(() => {
        setCurrentID(idInit)
    }, [idInit])

    const [, doFetchLoad] = useFetch(
        `${API_MASTERDATA}bank/${currentID}`)//{ error: errLoad, isLoading: isLoadLoad, response: respLoad }


    
        const [, doFetchCreateUpdate] = useFetch(
            `${API_MASTERDATA}bank`)//{ error: errCU, isLoading: isLoadCU, response: respCU }



    useEffect(() => {
        if (currentID === "") {
            return
        }
        doFetchLoad({
            method: 'GET',
            "Content-Type": "application/json"
        }).then(responce => {
            setEntity(responce.data)
            console.log(responce.data)
        })
    }, [currentID])


    const handleSave = () => {
        //сначала проверим заполненность

        var method = "POST"
        if (currentID !== "") {
            method = "PATCH"
        }

        doFetchCreateUpdate({
            method: method,
            "Content-Type": "application/json",
            data: entity
        }).then(responce => {
            console.log(responce)
            setEntity(responce.data)
            console.log("responce.result.status", responce.result.status)
            if (responce.result.status === "success") {
                handleClose();
            }
            console.log(responce.data)
        })


    }




    const confirmButtonTitle = "Загрузить";//useTranslation('confirmButtonTitle')
    const rejectButtonTitle = useTranslation('rejectButtonTitle')

    const createButtonTitle = useTranslation('createButton')
    const updateButtonTitle = useTranslation('updateButton')


    return (<Card>
        <Card.Header>
            <Card.Title as='h4'>{title}</Card.Title>
        </Card.Header>
        <Card.Body className="">
            {/* <Form className="form-horizontal"> */}

        

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('name')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('name')} value={entity.name} onChange={e => setEntity((prev) => { return { ...prev, name: e.target.value } })} />
                </Col>
            </Row>


            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('logoURL')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('logoURL')} value={entity.logoURL} onChange={e => setEntity((prev) => { return { ...prev, logoURL: e.target.value } })} />
                </Col>
            </Row>

            <Row className="mb-4">
                <Form.Label className="col-md-3">{useTranslation('bankCode')}</Form.Label>
                <Col md={9}>
                    <Form.Control type="text" placeholder={useTranslation('bankCode')} value={entity.bankCode} onChange={e => setEntity((prev) => { return { ...prev, bankCode: e.target.value } })} />
                </Col>
            </Row>



        



            <Row className="mb-0">
                {canCreate && currentID === "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {createButtonTitle} </Button>
                }

                {canUpdate && currentID !== "" &&
                    <Button onClick={() => { handleSave(); console.log(entity) }}> {updateButtonTitle} </Button>
                }


            </Row>






        </Card.Body>
    </Card>)
}
